<style scoped>
  @import './otp-methods.scss';
</style>
<script>
import { CONSTANT, SDK_ENUMS } from '../../../utils/constant'
import { mapGetters } from 'vuex'
import { EventBus } from '../../../event-bus.js'
import sharedService from '../../../utils/shared-service'
import Continue from '../continue/continue.vue'

export default {
  name: 'OtpMethods',
  components: {
    Continue
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      selectedOtpMethod: '',
      otpMethods: ''
    }
  },

  computed: {
    ...mapGetters(['validationData', 'enableMPT'])
  },

  created () {
    this.displayOtpMethods()
  },

  methods: {
    displayOtpMethods () {
      this.otpMethods = {}
      let supportedValidationChannels = this.validationData.supportedValidationChannels || []
      if (supportedValidationChannels.length > 0) {
        supportedValidationChannels.forEach(validationChannel => {
          let identityType = validationChannel.identityType || ''
          if (identityType.includes('EMAIL')) {
            this.otpMethods['Email a code to'] = (validationChannel.maskedValidationChannel)
          } else if (identityType.includes('MOBILE') || identityType.includes('SMS')) {
            this.otpMethods['Text another code to'] = validationChannel.maskedValidationChannel
          }
        })
      } else if (sharedService.verifyEmailId(this.validationData.maskedValidationChannel)) {
        this.otpMethods['Email a code to'] = this.validationData.maskedValidationChannel
      } else {
        this.otpMethods['Text another code to'] = this.validationData.maskedValidationChannel
      }
      this.otpMethods['Checkout as a guest'] = ''

      this.selectedOtpMethod = Object.keys(this.otpMethods)[0]
    },

    async resendOtp () {
      await this.$store.commit('lightBoxloaderOn', false)
      if (this.selectedOtpMethod === CONSTANT.GUEST_TXT) {
        if (this.enableMPT) {
          this.$store.dispatch('updateRememberMeConsent', false)
          sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.REGISTER_SCREEN, this.$router)
        } else {
          this.$store.commit('srciActionCode', SDK_ENUMS.SrciActionCodes.authSkipped)
          sharedService.srciScreenChange(CONSTANT.INLINE_SCREEN.GUEST_CHECKOUT_SCREEN, this.$router)
        }
      } else {
        EventBus.$emit('recallInitiateIdentity', this.otpMethods[this.selectedOtpMethod])
      }
    }
  }
}
</script>
<template>
  <div class="mb-5 otp-methods">
    <h4 class="text-center mt-4 font-weight-bold">
      {{ $t ('label.continueAnotherWay') }}
    </h4>
    <div class="main-wrapper mt-4 mb-5">
      <div class="main-container">
        <div
          v-for="(value, key) in otpMethods"
          :key="value"
          :value="key"
          class="border-bottom pl-3 row method-row"
        >
          <label class="radio text-break radio-align">
            <span class="ml-1">{{ key }}</span>
            <div class="ml-1">{{ value }}</div>
            <input
              :id="'otpMethod-' + key"
              v-model="selectedOtpMethod"
              :value="key"
              class="d-inline float-left"
              type="radio"
            >
            <div class="check d-md-inline otp-radio" />
          </label>
        </div>
      </div>
    </div>
    <div class="text-center">
      <continue
        @submit="resendOtp()"
      />
    </div>
  </div>
</template>
